// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__O02Gp","icon":"footer_icon__WUMze","foot":"footer_foot__eSk1A","disclosure":"footer_disclosure__RPR3M"};